import { getInactiveTotalCount } from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useQuery } from "react-query";

export default function useGetInactiveTotalCount() {
  //Fetching Total Inactive Count
  return useQuery("GetIactiveTotalCount", getInactiveTotalCount, {
    refetchOnWindowFocus: false,
  });
}
